import { Oval } from "react-loader-spinner";
import "./loaderSpinner.scss";

export function LoaderSpinner({ visible }: { visible: boolean }) {
  if (!visible) return null;
    return(
        <div className="loader-spinner-container">
            <Oval
            height="80"
            width="80"
            color="#000000"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={visible}
            />
        </div>
    )
}